<div class="password-policy-container">
    <mat-icon class="info">info</mat-icon>
    <div class="password-policy">
        {{ 'PasswordPolicy.Intro' | translate }}
        @if (securityPolicy) {
            <ul>
                <li [innerHTML]="'PasswordPolicy.PasswordHistoryCount' | translate: { passwordHistoryCount: securityPolicy.passwordHistoryCount }"></li>
                <li [innerHTML]="'PasswordPolicy.PasswordMinCasesLength' | translate: { passwordMinCasesLength: securityPolicy.passwordMinCasesLength }"></li>
                <li [innerHTML]="'PasswordPolicy.PasswordMaxCasesLength' | translate: { passwordMaxCasesLength: securityPolicy.passwordMaxCasesLength }"></li>
                <li [innerHTML]="'PasswordPolicy.PasswordMinUpperCasesLength' | translate: { passwordMinUpperCasesLength: securityPolicy.passwordMinUpperCasesLength }"></li>
                <li [innerHTML]="'PasswordPolicy.PasswordMinLowerCasesLength' | translate: { passwordMinLowerCasesLength: securityPolicy.passwordMinLowerCasesLength }"></li>
                <li [innerHTML]="'PasswordPolicy.PasswordMinDigitsLength' | translate: { passwordMinDigitsLength: securityPolicy.passwordMinDigitsLength }"></li>
                <li
                    [innerHTML]="
                        'PasswordPolicy.PasswordSpecialCases'
                            | translate
                                : {
                                      passwordMinSpecialCasesLength: securityPolicy.passwordMinSpecialCasesLength,
                                      passwordSpecialCases: securityPolicy.passwordSpecialCases | HtmlEncode
                                  }
                    "></li>
            </ul>
        }
    </div>
</div>
